module.exports = __webpack_public_path__ + "static/media/cherry-delivery.3129c5d6.png";